export type TabSettingI = {
  title: string;
  route: string;
  navigateTo: () => void;
  testID?: string;
  underConstruction?: boolean;
}

export interface SortByOptionsI {
  id: string;
  description: string;
}

export enum OrderTypes {
  DESC = "DESC",
  ASC = "ASC",
}

export const metricOptions = [ "van", "reefer" ];

export interface CommodityI {
  commodity_id: string;
  created_at: string;
  description: string;
  updated_at: string;
}

export interface SalespersonI {
  salesperson_id: string;
  salesperson: string;
}

export const ApprovalsSortByOptions: Array<SortByOptionsI> = [
  {
    id          : "pick_up_date",
    description : "Pick up Date",
  },
  { id: "drop_off_date", description: "Drop off Date" },
  { id: "created_at", description: "Creation Date" },
];

export const FromOptions: Array<SortByOptionsI> = [
  {
    id          : "ORIGIN",
    description : "Origin",
  },
  { id: "DESTINATION", description: "Destination" },
  { id: "BOTH", description: "Both" },
];

export const DistanceOptions: Array<SortByOptionsI> = [
  {
    id          : "25",
    description : "25 mi",
  },
  {
    id          : "50",
    description : "50 mi",
  },
  {
    id          : "100",
    description : "100 mi",
  },
  {
    id          : "150",
    description : "150 mi",
  },
  {
    id          : "200",
    description : "200 mi",
  },
];

export const statusOptions: Array<SortByOptionsI> = [
  {
    id          : "approved",
    description : "Approved",
  },
  {
    id          : "counter",
    description : "Counter",
  },
  {
    id          : "rejected",
    description : "Rejected",
  },
];
